import { ReactNode, forwardRef } from 'react';

import {
  Theme,
  WithStyles,
  alpha,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { formatHotkey } from '../utils/format-hotkey';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      border: '1px solid',
      borderRadius: theme.shape.borderRadius,
      color: 'var(--text-subdued)',
      borderColor: alpha(theme.palette.text.secondary, 0.2),
      whiteSpace: 'nowrap',
      padding: theme.spacing(0, 1),
      fontSize: '0.875rem',
      minWidth: 20,
      minHeight: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

interface KeyboardShortcutProps extends WithStyles<typeof styles> {
  hotkey?: string;
  children?: ReactNode;
}

const KeyboardShortcutImpl = forwardRef<HTMLSpanElement, KeyboardShortcutProps>(
  ({ hotkey, children, classes }, ref) => {
    const data = typeof children === 'string' ? children : hotkey;

    return (
      <span ref={ref} className={classes.root}>
        {formatHotkey(data)}
      </span>
    );
  },
);
KeyboardShortcutImpl.displayName = 'KeyboardShortcut';

export const KeyboardShortcut = withStyles(styles)(KeyboardShortcutImpl);
